var map = {
	"./XIcon.svg": 20626,
	"./borderFolderIcon.svg": 62510,
	"./buildingIcon.svg": 56784,
	"./businessFolderIcon.svg": 31914,
	"./checkCircleIcon.svg": 8074,
	"./dollarIcon.svg": 41882,
	"./editIcon.svg": 66764,
	"./eyeIcon.svg": 43445,
	"./folderBorderIcon.svg": 43162,
	"./folderIcon.svg": 7784,
	"./handShakeIcon.svg": 26529,
	"./helpIcon.svg": 59605,
	"./homeIcon.svg": 61433,
	"./infoIcon.svg": 49312,
	"./labelIcon.svg": 97576,
	"./libraryIcon.svg": 54939,
	"./linesArrowIcon.svg": 73224,
	"./logoutIcon.svg": 43878,
	"./manageAccountIcon.svg": 2260,
	"./outlookIcon.svg": 19247,
	"./plusIcon.svg": 68048,
	"./profileIcon.svg": 93977,
	"./signIcon.svg": 75055,
	"./simpleUserIcon.svg": 9735,
	"./sortIcon.svg": 69996,
	"./supportWhiteIcon.svg": 46944,
	"./triangleWarningIcon.svg": 31050,
	"./unitCorporativeIcon.svg": 57678,
	"./userSettingsIcon.svg": 61122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75088;